import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { logger } from 'shared/lib'
import { toastStore } from 'shared/ui'
import { ClientsApi } from 'entities/Clients/api/clients'
import { type RowClient } from 'entities/Clients/model/RowClient'
import { RenameClientModal } from 'pages/clients/ui/actions/rename/ui/RenameClientModal'

export const rename = async (row: RowClient) => {
  const modalId = nanoid()

  const onClose = () => {
    modalStore.closeModal(modalId)
  }

  const onRename = async (name: string) => {
    try {
      const { data } = await ClientsApi.renameClient(row.id, name)
      row.syncOrigin(data)
      onClose()
      toastStore.add({
        type: 'success',
        title: 'Client renamed',
      })
    } catch (error) {
      logger.error(error)
      toastStore.add({
        type: 'error',
        title: 'Something went wrong, try again.',
      })
    }
  }

  modalStore.addModal({
    id: modalId,
    title: 'Rename client',
    width: 480,
    pureContent: true,
    ModalContent: RenameClientModal,
    ModalContentProps: { name: row.clientName, onClose, onRename },
  })
}
